import lottie from 'lottie-web';

export default {
    props: {
        containerClassName: {
            type: String,
            default: 'lottie-animation-container'
        },
        startOnInit: {
            type: Boolean,
            default: true
        },
        loop: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        start() {
            lottie.loadAnimation({
                container: document.querySelector(`.${this.containerClassName}`),
                renderer: 'svg',
                loop: this.loop,
                autoplay: true,
                animationData: this.json
            });
        }
    },
    mounted() {
        if ( this.startOnInit ) {
            this.start();
        }
    }
}